import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import RfqBanner from "../components/RfqBanner";
import { PageBanner } from "./About";
import { PRODUCTS, PRODUCT_CATEGORIES } from "../data/content";

const Products = () => {
  const [category, setCategory] = useState("All");
  const filtered = category === "All" ? PRODUCTS : PRODUCTS.filter((p) => p.category === category);

  return (
    <>
      <PageBanner
        testId="products-banner"
        eyebrow="Product Catalogue"
        title="Our Products"
        description="High-quality tooling, Dies and precision components for industrial applications. All products are manufactured to customer drawings and are enquiry-driven."
      />

      <section data-testid="products-catalogue" className="py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-2" role="tablist" aria-label="Product categories">
            {PRODUCT_CATEGORIES.map((cat) => (
              <button
                key={cat}
                type="button"
                role="tab"
                aria-selected={category === cat}
                data-testid={`category-tab-${cat.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                onClick={() => setCategory(cat)}
                className={`text-sm font-medium px-4 py-2 border rounded-sm transition-colors duration-150 ${
                  category === cat
                    ? "bg-[#0B1329] text-white border-[#0B1329]"
                    : "bg-white text-slate-600 border-slate-300 hover:border-slate-500"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.05}>
                <article
                  data-testid={`product-card-${p.id}`}
                  className="h-full bg-white border border-slate-200 rounded-sm overflow-hidden group flex flex-col"
                >
                  <div className="overflow-hidden">
                    <img
                      src={p.img}
                      alt={p.alt}
                      loading="lazy"
                      className="h-52 w-full object-cover group-hover:scale-[1.03] transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6 flex flex-col flex-1">
                    <span className="self-start text-[11px] font-mono px-2 py-0.5 bg-slate-100 text-slate-600 border border-slate-200 rounded-sm">
                      {p.category}
                    </span>
                    <h2 className="mt-3 text-lg font-semibold text-slate-900">{p.name}</h2>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">{p.desc}</p>
                    <Link
                      to={`/contact?product=${encodeURIComponent(p.name)}`}
                      data-testid={`product-enquire-button-${p.id}`}
                      className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#2563EB] hover:text-[#1D4ED8]"
                    >
                      Request a Quote <ArrowRight size={14} />
                    </Link>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>

          <p className="mt-10 text-sm text-slate-500 max-w-3xl leading-relaxed">
            Dimensions, materials, tolerances and other technical specifications are confirmed
            against your drawings during the enquiry process. Detailed product specifications will
            be published here as they are finalised.
          </p>
        </div>
      </section>

      <RfqBanner />
    </>
  );
};

export default Products;
